import { QueryObserverOptions, useQuery } from 'react-query';
import { downloadFile } from '../api';
import { toast } from 'react-toastify';
import {useTranslation} from 'react-i18next';


type UseQueryOptionsKeys = Pick<QueryObserverOptions<number>, 'enabled'>;

export default function useDownloadFile(
  uploadId: number,
  options?: UseQueryOptionsKeys,
  
) {

  const {t} = useTranslation();
  const { data, isFetching, refetch } = useQuery(
    ['downloadedFile', uploadId],
    () => downloadFile(uploadId), 
    {
      onError: error => {
       toast.error(t('toast.title.error.generate.pdf'));
      },
      ...options,
    }
  );

  

  return { file: data, isFetching, downloadFile: refetch };
}


